import templateUrl from "emun.order/parts/parts-order-list.htm";

export default () => ({
  templateUrl
});
